;(function($, undefined){

    var rnn = window.rnn;
    var $window = $(window);
    var stickySelector = ".stickTo:not(.markerClone)";
    // we want a different sticky behaviour for the standard_article page for subscriber
    var enableStickyArticleSubscriber = (typeof(disable_subscriber_layout) !== 'undefined' && disable_subscriber_layout !== 'yes') && rnn.modules.user.isSubscriber();

    function getMarkerClone($element) {
        var markerClone = $element.data("markerclone");

        if (!markerClone) {
            markerClone = $(document.createElement($element[0].tagName));
            markerClone.attr('class', $element.attr('class') + ' markerClone').css({'visibility':'hidden', 'height':$element.outerHeight()}).hide();
            $element.before(markerClone);
            $element.data('markerclone', markerClone);
        }

        return markerClone;
    }

    function stick() {
        var $element = $(this);
        var bottom = $element.data('stickto') == 'bottom';
        var markerclone = getMarkerClone($element).show();
        var originalTop = markerclone.offset().top;
        var originalHeight = $element.outerHeight();
        // shouldStick when controls are below the window. Once scrolled down past the controls don't stick.
        var shouldStick = (bottom && $window.scrollTop() + $window.height() < originalTop + originalHeight && $window.scrollTop() < originalTop) ||
                $window.scrollTop() > originalTop;
        var left, width;

        if (shouldStick) {
            left = markerclone.offset().left;
            width = markerclone.width();

            $element.addClass("stuck");
            $element.css({"position":"fixed","left": left,"width": width});

            if (bottom) {
                $element.css({'bottom':'0'});
            } else {
                $element.css({'top':'0'});
            }
        } else if ($element.is('.stuck')) {
            markerclone.hide();
            $element.removeClass("stuck");
            $element.css({"position":markerclone.css('position'),"left": "","right": ""});
        } else {
            markerclone.hide();
        }
    }

    function stickyScrolling() {

        var $top = $('.top, .wrapper');
        var $header = $('header, .wrapper');

        var scrollPos = 0;
        var prevScrollPos = scrollPos;

        var scrollDir = 'down';
        var prevScrollDir = scrollDir;

        var scrollDirChanged = 0;

        $window.on('scroll resize', function() {
            scrollPos = $window.scrollTop();
            scrollDir = scrollPos > prevScrollPos ? 'down' : 'up';

            // Capture the scroll position at the point that scrolling changes direction
            if (scrollDir !== prevScrollDir) scrollDirChanged = scrollPos;

            if (scrollDir === 'down') {
                if (scrollPos > 1000) {
                    $header.addClass('minimise-header');
                    if (enableStickyArticleSubscriber) {
                      $('.sitenav').removeClass('hide-nav');
                    }
                    if (scrollPos > 1500) {
                        $top.addClass('minimise-top').addClass('remove-top');
                    } else {
                        $top.removeClass('minimise-top').removeClass('remove-top');
                    }
                } else {
                    $header.removeClass('minimise-header');
                }
            } else {
                $top.removeClass('minimise-top').removeClass('remove-top');

                // If user has scrolled 500px since scroll direction changed to upwards:
                if (scrollDirChanged - scrollPos >= 500) {
                  $header.removeClass('minimise-header');
                  if (enableStickyArticleSubscriber) {
                    $('.sitenav').addClass('hide-nav');
                  }
                }
            }

            prevScrollPos = scrollPos;
            prevScrollDir = scrollDir;
        });
    }

    function mobileStickyScrolling() {
        addOrRemoveScrolledClass();

        $window.scroll(function () {
            addOrRemoveScrolledClass();
        });
    }

    function addOrRemoveScrolledClass() {
        var $mastheadLogoEl = $('.masthead');
        var $navMenuEl = $('.menu-bar');

        if($(this).scrollTop() > 0) {
            $mastheadLogoEl.addClass("move-logo-up").removeClass("move-logo-down");
            $navMenuEl.addClass("move-nav-menu-up").removeClass("move-nav-menu-down");
        }
        else {
            if($mastheadLogoEl.hasClass("move-logo-up")) {
                $mastheadLogoEl.addClass("move-logo-down").removeClass("move-logo-up");
                $navMenuEl.addClass("move-nav-menu-down").removeClass("move-nav-menu-up");
            }
        }
    }

    /////////////////////
    // Initialise Stickies
    /////////////////////
    function initSticky() {
        var $stickies = $(stickySelector);

        if ($stickies.length > 0) {
            $stickies.each(stick);

            $window.scroll(function() {
                $stickies.each(stick);
            });
        }

        if (rnn.site.isMobile)  {
            // Change the home link in the menu to a home icon
            var $homeIconEl = $('.nav-pills > li:first-child > a');
            if($homeIconEl.text().indexOf('Home') != -1) {
                $homeIconEl.addClass("tangram-icon icon-home nav-icon").text("");
            }

            mobileStickyScrolling();
        } else {
            stickyScrolling();
        }
    }

    rnn.modules.register("sticky", {
        init: initSticky
    });

})(jQuery);
